enum CompletionStatus {
  Saved = 0,
  Released = 10,
  Submitted = 20,
  Completed = 90
}
enum Status {
  Saved = 0,
  Released = 11,
  Submitted = 21,
  Resbumitted = 22,
  RecommendedBySupervisor = 61,
  NotRecommendedBySupervisor = 62,
  RecommendedByAdmin = 91,
  NotRecommendedByAdmin = 92
}

enum TrainingCentreType {
  CommunityBased = 1,
  HospitalBased = 2
}

enum ActionType {
  AdminRelease = 11,
  TraineeSubmit = 21,
  TraineeResbumit = 22,
  SupervisorRecommend = 61,
  SupervisorNotRecommend = 62,
  AdminRecommend = 91,
  AdminNotRecommend = 92
}

enum UploadType {
  SupportingDocument = 1
}

enum LearningPortfolioCompletionStatus {
  Saved = 0,
  Released = 10,
  Submitted = 20,
  Completed = 90
}

enum LearningPortfolioStatus {
  Saved = 0,
  Released = 11,
  Submitted = 21,
  Resbumitted = 22,
  EndorsedBySupervisor = 51,
  RejectBySupervisor = 52
}
enum LearningPortfolioActionType {
  AdminRelease = 11,
  TraineeSubmit = 21,
  TraineeResbumit = 22,
  SupervisorEndorse = 51,
  SupervisorReject = 52
}

enum LogDairyCompletionStatus {
  Saved = 0,
  Released = 10,
  Submitted = 20,
  Completed = 90
}

enum LogDairyStatus {
  Saved = 0,
  Released = 11,
  Submitted = 21,
  Resbumitted = 22,
  EndorsedBySupervisor = 51,
  RejecttedBySupervisor = 52
}

enum LogDairyActionType {
  AdminRelease = 11,
  TraineeSubmit = 21,
  TraineeResbumit = 22,
  EndorsedBySupervisor = 51,
  RejecttedBySupervisor = 52
}

enum TrainingFeedbackCompletionStatus {
  NoStarted = 0,
  Submitted = 20,
  Completed = 90
}

enum TrainingFeedbackStatus {
  NoStarted = 0,
  Submitted = 21,
  Completed = 91
}

enum AssessmentCompletionStatus {
  NoStarted = 0,
  Saved = 20,
  Completed = 90
}

enum AssessmentStatus {
  NoStarted = 0,
  Saved = 21,
  Completed = 91
}

enum AssessmentResult {
  Pending = 0,
  Recommended = 91,
  NotRecommended = 93
}

enum Type {
  Rotation = 1,
  PastLocalRotation = 2,
  PastOverseasRotation = 3
}

export const rotationEnum = {
  CompletionStatus,
  Status,
  ActionType,
  UploadType,
  LearningPortfolioCompletionStatus,
  LearningPortfolioStatus,
  LearningPortfolioActionType,
  LogDairyCompletionStatus,
  LogDairyStatus,
  LogDairyActionType,
  TrainingFeedbackCompletionStatus,
  TrainingFeedbackStatus,
  AssessmentCompletionStatus,
  AssessmentStatus,
  AssessmentResult,
  Type,
  TrainingCentreType
}
